import { createSlice } from "@reduxjs/toolkit";
import {
  checkAuthStatus,
  forgotPassword,
  loginUser,
  SetupNewPassword,
  verifyTwoFactorCode,
} from "./authThunks";
import { updateVendorsonhome } from "./VendorThunks";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      state.vendor = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("vendor");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateVendorsonhome.fulfilled, (state, action) => {
        state.vendor = action.payload;
        localStorage.setItem("vendor", JSON.stringify(action.payload)); // ✅ This will keep localStorage up to date
      })
      .addCase(SetupNewPassword.fulfilled, (state, action) => {
        state.vendor = action.payload;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.vendor = action.payload;
      })
      .addCase(verifyTwoFactorCode.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user || action.payload;
        state.token = action.payload.token || null;
        state.userData = action.payload.userData || null;
        state.refreshToken = action.payload.refreshToken || null;
        if (state.token) {
          localStorage.setItem("token", state.token);
        }
        if (state.user) {
          localStorage.setItem("user", JSON.stringify(state.user)); // <-- Store user info
        }
        if (state.userData) {
          localStorage.setItem("vendor", JSON.stringify(state.userData));
        }
        if (state.refreshToken) {
          localStorage.setItem(
            "refreshToken",
            JSON.stringify(state.refreshToken)
          );
        }
      })
      .addCase(checkAuthStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.hasChecked = true; // ✅ mark auth check complete
        state.userData = action.payload.userData || null;
        if (state.userData) {
          localStorage.setItem("vendor", JSON.stringify(state.userData));
        }
      })
      .addCase(checkAuthStatus.rejected, (state, action) => {
        state.user = null;
        state.error = action.payload;
        state.loading = false;
        state.hasChecked = true; // ✅ mark auth check complete
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
